import logo from "../../assets/logo_affida.png";
import style from "./HeaderAffida.module.css";
import AuthIconButton from "../log-handler/LogHandler";
import { IconButton, Tooltip } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { useAuth } from "../../providers/AuthProvider";

interface Props {
  onMenuOpen?: () => void;
}

export default function HeaderAffida({ onMenuOpen }: Props) {
  const { user } = useAuth();
  return (
    <div className={"container"} style={{ marginBottom: "0.5em" }}>
      <div className={style.header}>
        {onMenuOpen && (
          <IconButton
            className={style.menuButton}
            onClick={onMenuOpen}
            aria-label="Apri menu di navigazione"
            size="small"
          >
            <MenuIcon />
          </IconButton>
        )}
        {!user && <img src={logo} alt="Logo" className={style.logo} />}
        {user && (
          <span
            style={{ display: "block", textAlign: "left", fontSize: "12px" }}
          >
            Benvenuto <b>{user?.email}</b>
          </span>
        )}
        <span className={style.message} style={{ marginRight: "1em" }}>
          Società <strong>iscritta OAM</strong> al numero <strong>M325</strong>
        </span>
        <div className="flex-row">
          <AuthIconButton />
        </div>
      </div>
    </div>
  );
}
